import { render, staticRenderFns } from "./Patterns.vue?vue&type=template&id=ab403d7a&"
import script from "./Patterns.vue?vue&type=script&lang=ts&"
export * from "./Patterns.vue?vue&type=script&lang=ts&"
import style0 from "./Patterns.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports